import useSWR from 'swr';
import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';
import useUser from './useUser';

export const useBrands = () => {
	const { user, isInitialised } = useUser();
	const req = useSWR(() => (isInitialised ? `/api/${user ? '' : 'public/'}brands` : null));

	return req;
};
